import {
  EcommerceMerchantAction,
  LOAD_ECOMMERCE_ACTIVE_MERCHANT,
  LOAD_ECOMMERCE_ACTIVE_MERCHANT_FAIL,
  LOAD_ECOMMERCE_ACTIVE_MERCHANT_SUCCESS,
  LOAD_ECOMMERCE_MERCHANT,
  LOAD_ECOMMERCE_MERCHANT_FAIL,
  LOAD_ECOMMERCE_MERCHANT_SUCCESS,
  LoadEcommerceActiveMerchant,
  LoadEcommerceActiveMerchantFail,
  LoadEcommerceActiveMerchantSuccess,
  LoadEcommerceMerchant,
  LoadEcommerceMerchantFail,
  LoadEcommerceMerchantSuccess,
} from "../actions";

export interface IEcommerceMerchantEntityState {
  merchantId?: any,
  merchantHash?: any,
  publicKey?: any,
  merchant?: any,
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceMerchantState {
  entities: { [websiteId: number]: IEcommerceMerchantEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceMerchantState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceMerchantState = initialState, action: EcommerceMerchantAction): IEcommerceMerchantState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_MERCHANT:
      payload = (<LoadEcommerceMerchant>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_MERCHANT_SUCCESS:
      payload = (<LoadEcommerceMerchantSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            merchantId: payload.merchantId,
            merchantHash: payload.merchantHash,
            publicKey: payload.publicKey,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_MERCHANT_FAIL:
      payload = (<LoadEcommerceMerchantFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };



    case  LOAD_ECOMMERCE_ACTIVE_MERCHANT:
      payload = (<LoadEcommerceActiveMerchant>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_ACTIVE_MERCHANT_SUCCESS:
      payload = (<LoadEcommerceActiveMerchantSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            merchant: payload.merchant,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_ACTIVE_MERCHANT_FAIL:
      payload = (<LoadEcommerceActiveMerchantFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
